// imports
import { createSlice } from '@reduxjs/toolkit';

// Initial state of the water data slice
export const initialWaterDataState = {
  selectedSector: 'integrated-water-availability',
  selectedModel: 'iwa-assessment-outputs-conus-2025',
  selectedVariable: "sui",
  temporalResolution: 'monthly',
  selectedStartMonth: "January",
  selectedStartYear: null as string | null,
  selectedEndMonth: null,
  selectedEndYear: null,
  opacity: 65,
  appliedSector: 'integrated-water-availability',
  appliedModel: 'iwa-assessment-outputs-conus-2025',
  appliedVariable: 'sui',
  appliedTemporalResolution: 'monthly',
  appliedStartMonth: 'January',
  appliedStartYear: null as string | null,
};

// For each selected value in the Available Water Data accordion
export const waterDataSlice = createSlice({
  name: 'waterData',
  initialState: initialWaterDataState,
  reducers: {
    setSelectedSector: (state, action) => {
      state.selectedSector = action.payload;
    },
    setSelectedModel: (state, action) => {
      state.selectedModel = action.payload;
    },
    setTemporalResolution: (state, action) => {
      state.temporalResolution = action.payload;
    },
    setSelectedVariable: (state, action) => {
      state.selectedVariable = action.payload;
    },
    setSelectedStartMonth: (state, action) => {
      state.selectedStartMonth = action.payload;
    },
    setSelectedStartYear: (state, action) => {
      state.selectedStartYear = action.payload;
    },
    setSelectedEndMonth: (state, action) => {
      state.selectedEndMonth = action.payload;
    },
    setSelectedEndYear: (state, action) => {
      state.selectedEndYear = action.payload;
    },
    setOpacity: (state, action) => {
      state.opacity = action.payload;
    },
    setAppliedSector: (state, action) => {
      state.appliedSector = action.payload;
    },
    setAppliedModel: (state, action) => {
      state.appliedModel = action.payload;
    },
    setAppliedVariable: (state, action) => {
      state.appliedVariable = action.payload;
    },
    setAppliedStartMonth: (state, action) => {
      state.appliedStartMonth = action.payload;
    },
        setAppliedStartYear: (state, action) => {
      state.appliedStartYear = action.payload;
    },
    setAppliedTemporalResolution: (state, action) => {
      state.appliedTemporalResolution = action.payload;
    },
  },
});

export const {
  setSelectedSector,
  setSelectedModel,
  setTemporalResolution,
  setSelectedVariable,
  setSelectedStartMonth,
  setSelectedStartYear,
  setSelectedEndMonth,
  setSelectedEndYear,
  setOpacity,
  setAppliedSector,
  setAppliedModel,
  setAppliedVariable,
  setAppliedTemporalResolution,
  setAppliedStartMonth,
  setAppliedStartYear,
} = waterDataSlice.actions;
export default waterDataSlice.reducer;
